import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller, useFormContext } from 'react-hook-form';
import { getMaxDate, getMinDate } from './helpers';
import { FormInputProps } from 'types/components';
import { useEffect } from 'react';
import dayjs from 'dayjs';

export const FormInputDate = ({
    name,
    label,
    required,
    helperText,
    maxDateFieldName,
    minDateFieldName,
    maxDate,
    minDate,
}: FormInputProps) => {
    const { control, setValue, watch } = useFormContext();

    useEffect(() => {
        const value = watch(name);

        if (!value) {
            const date = new Date();
            if (minDateFieldName) {
                date.setDate(date.getDate() + 1);
            }
            setValue(name, date);
        }
    }, []);

    const watchedMaxDate = maxDateFieldName ? watch(maxDateFieldName) : undefined;
    const watchedMinDate = minDateFieldName ? watch(minDateFieldName) : undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
                name={name}
                control={control}
                rules={{
                    required: required,
                }}
                render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <>
                        <DatePicker
                            value={dayjs(value)}
                            onChange={onChange}
                            minDate={
                                watchedMinDate || minDate
                                    ? (getMinDate({
                                          watchedMinDate: watchedMinDate,
                                          minDate: minDate,
                                      }) as dayjs.Dayjs)
                                    : undefined
                            }
                            maxDate={
                                watchedMaxDate || maxDate
                                    ? (getMaxDate({
                                          watchedMaxDate: watchedMaxDate,
                                          maxDate: maxDate,
                                      }) as dayjs.Dayjs)
                                    : undefined
                            }
                            format='YYYY-MM-DD'
                            label={label}
                            slotProps={{
                                textField: {
                                    helperText: error ? (error.message ? error.message : helperText) : null,
                                    error: Boolean(error),
                                },
                            }}
                        />
                    </>
                )}
            />
        </LocalizationProvider>
    );
};
